
//#region 代码编辑器
import VCode from "./VCodeMirror"
import vConsole from "./codeMirrorConsole"

const vCode = new VCode();

(<any>window).vCode = {
    init: () => {
        vCode.init.call(vCode);
        (<any>$('[data-toggle="tooltip"]')).tooltip();
        vConsole.clear();
    },
    run: () => {
        vCode.run.call(vCode);
    },
    clear: () => {
        vCode.clear.call(vCode);
        document.getElementById("cmConsole").innerHTML = "";
    }
};

//#endregion